import type { FaireProductEntity } from "../../entity_types/product";

export const p_4p74tvh9qq: FaireProductEntity = {
  token: "p_4p74tvh9qq",
  type: "product",
  name: "WIRI Pepper Sauce",
  brandToken: "b_n2mfxxer77",
  brandName: "WIRI",
  imageUrl:
    "https://cdn.faire.com/fastly/d12281ac107523d96ce9901d49108b1ff09bb03e7529bea98c319a64fc85b215.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70441d507c203798e57e377403a77ee92a69063180f6cb8cfaf937ef7de50a9f.jpeg",
    "https://cdn.faire.com/fastly/2907bbfd13155bd0ee501d756213b5125093dc9920db2dfd2eb0dc5bcf7cd97f.jpeg",
  ],
  priceDollars: 22.4,
  description:
    "WIRI is made from the whole fresh Wiri Wiri pepper — rare, fruity, and searingly bright — paired with four considered ingredients and nothing else.\n\nEvery bottle arrives in an embossed keepsake box. Made for the table, not the pantry.\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:25.765Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
